// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-left.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/arrow-left'

import { Icon, type IconComponentProps } from '../icon'

export const ArrowLeftIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
